/* eslint-disable consistent-return */
import { isValidPhoneNumber } from 'react-phone-number-input';
// import loadable from '@loadable/component';

// const { isValidPhoneNumber } = loadable.lib(() => import('react-phone-number-input'));
// const RPNI = loadable.lib(() => import('react-phone-number-input'));

export const isEmpty = value => value === undefined || value === null || value === '';

export const intlPhoneNumber = (value) => {
    // const { isValidPhoneNumber } = await import('react-phone-number-input');
    // if (!isEmpty(value) && !isValidPhoneNumber(value)) {
    if (!isEmpty(value) && !isValidPhoneNumber(value)) {
        return 'Please provide a valid phone number. Country codes (\'+1\') are not required.';
    }
};
